<div class="nav-sidebar-shell" (clickOutside)="onClickOutside()">
<div class="menu-action-icon burger-menu" *ngIf="isMobileVersion && showNavSidebar && !hasHideMenuParam"
  (click)="toggleMenu()" [ngClass]="{'expanded': isExpanded}">
  <ng-icon [name]="isExpanded ? 'heroXMark' : 'heroBars3'"></ng-icon>
  <span class="burger-menu-label">{{ 'SIDEBAR.MENU' | translate }}</span>
</div>
<div class="d-flex flex-column justify-content-start align-items-center nav-sidebar"
  [ngClass]="{'hideable': isMobileVersion, 'setup-hidden': !isMobileVersion && !showNavSidebar, 'expanded': isExpanded}">
  <div class="rosie-logo-sidebar-wrapper">
    <div [routerLink]="['/']" class="rosie-logo-white rosie-logo-sidebar"></div>
  </div>
  <div class="sidebar-business-title">{{businessTitle}}</div>
  <rosie-switch-account></rosie-switch-account>
  <div class="separator full w-100 sidebar-separator"></div>
  <ng-container *ngFor="let item of navSidebarItems; let last = last">
    <div *ngIf="shouldShowNavItem(item.key)" class="d-flex sidebar-item align-items-center position-relative"
      [disabled]="hasTrialExpired" [routerLink]="'/'+getKebabCaseKey(item.key)" (mouseenter)="onMouseEnter(item.key)"
      (mouseleave)="onMouseLeave(item.key)" #rla="routerLinkActive" [routerLinkActive]="['active']"
      (click)="handleSelection(item.key)"
      [ngClass]="{'sidebar-spacing': !last, 'pointer-events-none': hasTrialExpired}">
      <ng-icon class="sidebar-icon" [name]="getIcon(item.key)"
        [color]="isHovered(item.key) || rla.isActive ? '#FFFFFF' : '#7F728A'"></ng-icon>
      <div>
        <div>{{ getTranslationKey(item.key) | translate }}</div>
        <div class="setup-guide-reminder"
          *ngIf="item.key === NavSidebarItem.Setup && !hasCreditCardOnFile && !rla.isActive && (isUserOnFreeMinutesBillingVersion || isUserOnTrialBasedBilling)">
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="7" viewBox="0 0 6 7" fill="none">
            <circle cx="3" cy="3.5" r="3" fill="#FBBF24" />
          </svg>
          Finish Setup
        </div>
      </div>
    </div>
  </ng-container>
  <div class="sidebar-cards-section">
    <rosie-card-stack (cardDismissed)="onCardDismiss($event)">
      <ng-template rosieStackCard rosieStackCardId="crm-integrations"
                   [rosieStackCardDismissible]="true"
                   [rosieStackCardVisible]="shouldShowCrmIntegrationsBanner"
                   let-dismiss="dismiss">
        <rosie-crm-integrations-banner (dismissed)="dismiss()"></rosie-crm-integrations-banner>
      </ng-template>
      <ng-template rosieStackCard rosieStackCardId="lead-sources"
                   [rosieStackCardDismissible]="true"
                   [rosieStackCardVisible]="shouldShowLeadSourcesBanner"
                   let-dismiss="dismiss">
        <rosie-lead-sources-banner (dismissed)="dismiss()"></rosie-lead-sources-banner>
      </ng-template>
      <ng-template rosieStackCard rosieStackCardId="website-chat"
                   [rosieStackCardDismissible]="true"
                   [rosieStackCardVisible]="shouldShowWebsiteChatBanner"
                   let-dismiss="dismiss">
        <rosie-website-chat-banner (dismissed)="dismiss()"></rosie-website-chat-banner>
      </ng-template>
      <ng-template rosieStackCard rosieStackCardId="waterfall-transfers"
                   [rosieStackCardDismissible]="true"
                   [rosieStackCardVisible]="shouldShowWaterfallTransfersBanner"
                   let-dismiss="dismiss">
        <rosie-waterfall-transfers-banner (dismissed)="dismiss()"></rosie-waterfall-transfers-banner>
      </ng-template>
      <ng-template rosieStackCard rosieStackCardId="message-taking"
                   [rosieStackCardDismissible]="true"
                   [rosieStackCardVisible]="shouldShowMessageTakingBanner"
                   let-dismiss="dismiss">
        <rosie-message-taking-banner (dismissed)="dismiss()"></rosie-message-taking-banner>
      </ng-template>
      <ng-template rosieStackCard rosieStackCardId="app-download"
                   [rosieStackCardDismissible]="true"
                   [rosieStackCardVisible]="shouldShowAppBanner"
                   let-dismiss="dismiss">
        <rosie-app-download-banner [variant]="'sidebar'" [dismissible]="true" (dismissed)="dismiss()"></rosie-app-download-banner>
      </ng-template>
      <ng-template rosieStackCard rosieStackCardId="website-texting"
                   [rosieStackCardDismissible]="true"
                   [rosieStackCardVisible]="shouldShowWebsiteTextingBanner"
                   let-dismiss="dismiss">
        <rosie-website-texting-banner (dismissed)="dismiss()"></rosie-website-texting-banner>
      </ng-template>
      <ng-template rosieStackCard rosieStackCardId="feedback"
                   [rosieStackCardVisible]="shouldShowFeedback">
        <rosie-feedback></rosie-feedback>
      </ng-template>
    </rosie-card-stack>
  </div>
  <div class="flex-full d-flex align-items-center flex-direction-column justify-content-center">
    <div class="billing-alert" *ngIf="showBillingAlert" [ngClass]="{'mb-2 mt-1': isMobileVersion}">
      <rosie-billing-alert></rosie-billing-alert>
    </div>
  </div>

  <div class="usage-status-item" *ngIf="hasReachedTestCallStep">
    <rosie-usage-status></rosie-usage-status>
  </div>
</div>
</div>
<ngx-smart-modal #subscriptionModal disableRefocus identifier="subscriptionModal"
  [customClass]="hasCreditCardAdded && !isCanceled ? 'subscription-modal plan-change-layout' : 'subscription-modal credit-card-entry-layout'"
  [closable]="false" (onAnyCloseEventFinished)="handleSubscriptionCancel()" [dismissable]="!hasTrialExpired">
  <div class="premium-wrapper-header" *ngIf="subscriptionData?.feature">
    <img class="is-premium-icon-stars" src="assets/images/diamond-yellow-stars.svg" alt="Premium">
    <div class="ml-1 title">{{ 'CONFIGURATION.PREMIUM_FEATURE' | translate }}</div>
    <ng-icon class="premium-arrow-icon" [size]="'14px'" [color]="'#D97706'" [name]="'heroArrowRight'"></ng-icon>
    <div class="description">To use {{featureName}}, upgrade to the {{subscriptionData?.plan}} plan.</div>
  </div>
  <rosie-subscription (onCancel)="handleSubscriptionCancel()"></rosie-subscription>
</ngx-smart-modal>
<ngx-smart-modal #trialExpiredModal disableRefocus identifier="trialExpiredModal" [customClass]="'trial-expired-modal'"
  [closable]="false" [dismissable]="false">
  <div class="trial-expired-modal-content modal-content">
    <div class="trial-expired-modal-title">Activate 3-day Trial Extension</div>
    <div class="trial-expired-modal-subtitle">Your original trial has expired, but don't worry...</div>
    <div class="trial-expired-modal-descriptions-wrapper">
      <div class="trial-expired-modal-description d-flex align-items-center">
        <ng-icon class="expired-check-icon" [name]="'heroCheckCircle'" [size]="'24px'" [color]="'#9332E0'"
          [strokeWidth]="'2'"></ng-icon>
        <span class="expired-check-text">Your agent and all settings have been saved</span>
      </div>
      <div class="trial-expired-modal-description d-flex align-items-center">
        <ng-icon class="expired-check-icon" [name]="'heroCheckCircle'" [size]="'24px'" [color]="'#9332E0'"
          [strokeWidth]="'2'"></ng-icon>
        <span class="expired-check-text">Includes access to all of Rosie’s features</span>
      </div>
      <div class="trial-expired-modal-description d-flex align-items-center">
        <ng-icon class="expired-check-icon" [name]="'heroCheckCircle'" [size]="'24px'" [color]="'#9332E0'"
          [strokeWidth]="'2'"></ng-icon>
        <span class="expired-check-text">Extend trial by adding a credit card</span>
      </div>
    </div>
    <div class="trial-expired-modal-description important">You will not be charged at this time. Cancel anytime.</div>
    <div class="d-flex justify-content-center">
      <rosie-button [translationKey]="'Extend Trial'" [customClass]="'wider'" class="trial-expired-modal-button"
        (click)="extendTrial()"></rosie-button>
    </div>
    <div class="trial-expired-action-wrapper" [ngClass]="{'justify-content-center': !hasMultipleBusinesses}">
      <div class="trial-action" [hidden]="!hasMultipleBusinesses">
        <ng-icon [name]="'heroArrowsRightLeft'" [size]="'20px'" [color]="'#7F728A'" [strokeWidth]="'2'"></ng-icon>
        <span class="trial-action-text"><rosie-switch-account></rosie-switch-account></span>
      </div>
      <div class="trial-action">
        <ng-icon [name]="'heroArrowRightStartOnRectangle'" [size]="'20px'" [color]="'#7F728A'"
          [strokeWidth]="'2'"></ng-icon>
        <span class="trial-action-text" (click)="logout()">Log Out</span>
      </div>
    </div>
  </div>
</ngx-smart-modal>